// import React, { useState, useEffect } from "react";
// import { collection, addDoc, getDocs } from "firebase/firestore";
// import { db } from "../../firebase";
// import Swal from "sweetalert2";

// const AddVideoOglyd = () => {
//   const [videoData, setVideoData] = useState({
//     videoName: "",
//     videoDesc: "",
//     ageCategory: "",
//     videoId: "",
//     book_uid: "",
//     bookName: "",
//   });

//   const [books, setBooks] = useState([]); // Стейт для збереження списку книг

//   useEffect(() => {
//     const fetchBooks = async () => {
//       const booksCollection = await getDocs(collection(db, "product"));
//       const booksList = booksCollection.docs.map((doc) => ({
//         uid: doc.id, // UID книги
//         ...doc.data(), // Інші дані книги
//       }));
//       setBooks(booksList);
//     };

//     fetchBooks();
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setVideoData({ ...videoData, [name]: value });
//   };

//   const handleUpload = async () => {
//     // Валідація введених даних
//     if (!videoData.videoName || !videoData.videoDesc) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Назва відео та опис є обов'язковими для заповнення!",
//       });
//       return;
//     }

//     try {
//       // Додайте дані до колекції `videoV` в Firebase
//       const docRef = await addDoc(collection(db, "videoV"), videoData);
//       console.log("Дані успішно додані до Firebase:", docRef.id);

//       // Показ повідомлення про успішне додавання
//       Swal.fire({
//         icon: "success",
//         title: "Успішно",
//         text: "Відео успішно додано!",
//       });

//       // Очистіть поля вводу
//       setVideoData({
//         videoName: "",
//         videoDesc: "",
//         ageCategory: "",
//         videoId: "",
//         book_uid: "",
//         bookName: "",
//       });
//     } catch (error) {
//       console.error("Помилка при додаванні даних до Firebase:", error);

//       // Показ повідомлення про помилку
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Сталася помилка при додаванні відео. Спробуйте ще раз.",
//       });
//     }
//   };

//   const handleBookChange = (e) => {
//     const selectedBook = books.find((book) => book.uid === e.target.value);
//     setVideoData({
//       ...videoData,
//       book_uid: selectedBook.uid,
//       bookName: selectedBook.bookName, // Припускаючи, що `bookName` є полем у даних книги
//     });
//   };

//   return (
//     <div>
//       <h2>Завантажити відео</h2>
//       <div>
//         <label htmlFor="videoName">Назва відео:</label>
//         <input
//           type="text"
//           id="videoName"
//           name="videoName"
//           value={videoData.videoName}
//           onChange={handleInputChange}
//         />
//       </div>
//       <div>
//         <label htmlFor="videoDesc">Опис відео:</label>
//         <textarea
//           id="videoDesc"
//           name="videoDesc"
//           value={videoData.videoDesc}
//           onChange={handleInputChange}
//         />
//       </div>
//       <div>
//         <label htmlFor="ageCategory">Вікова категорія:</label>
//         <input
//           type="text"
//           id="ageCategory"
//           name="ageCategory"
//           value={videoData.ageCategory}
//           onChange={handleInputChange}
//         />
//       </div>
//       <div>
//         <label htmlFor="videoId">ID відео:</label>
//         <input
//           type="text"
//           id="videoId"
//           name="videoId"
//           value={videoData.videoId}
//           onChange={handleInputChange}
//         />
//       </div>
//       <div>
//         <label htmlFor="bookSelect">Виберіть книгу:</label>
//         <select id="bookSelect" onChange={handleBookChange}>
//           <option value="">Оберіть книгу</option>
//           {books.map((book) => (
//             <option key={book.uid} value={book.uid}>
//               {book.bookName}
//             </option>
//           ))}
//         </select>
//       </div>
//       <button onClick={handleUpload}>Завантажити відео</button>
//     </div>
//   );
// };

// export default AddVideoOglyd;
import React, { useState, useEffect } from "react";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";

const AddVideoOglyd = () => {
  const [videoData, setVideoData] = useState({
    videoName: "",
    videoDesc: "",
    ageCategories: [],
    videoId: "",
    book_uid: "",
    bookName: "",
  });

  const [books, setBooks] = useState([]);
  const [ageCategories, setAgeCategories] = useState([]); // 🔹 Список вікових категорій з Firebase
  const [selectedAges, setSelectedAges] = useState([""]); // 🔹 Масив вибраних категорій

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const booksCollection = await getDocs(collection(db, "product"));
        const booksList = booksCollection.docs.map((doc) => ({
          uid: doc.id,
          ...doc.data(),
        }));
        setBooks(booksList);
      } catch (error) {
        console.error("❌ Помилка отримання книг:", error);
      }
    };

    const fetchAgeCategories = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "filters"));
        const filtersData = querySnapshot.docs.map((doc) => doc.data());

        const ageFilter = filtersData.find(
          (filter) => filter.transliter === "yearGroup"
        );

        if (ageFilter) {
          setAgeCategories(ageFilter.list);
        }
      } catch (error) {
        console.error("❌ Помилка отримання вікових груп:", error);
      }
    };

    fetchBooks();
    fetchAgeCategories();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setVideoData({ ...videoData, [name]: value });
  };

  // 🟢 **Зміна вікової категорії в конкретному індексі масиву**
  const handleAgeChange = (index, event) => {
    const updatedAges = [...selectedAges];
    updatedAges[index] = event.target.value;
    setSelectedAges(updatedAges);
  };

  // 🟢 **Додавання нової вікової категорії**
  const addAgeGroup = () => {
    setSelectedAges([...selectedAges, ""]);
  };

  // 🟢 **Видалення вікової категорії**
  const removeAgeGroup = (index) => {
    const updatedAges = selectedAges.filter((_, i) => i !== index);
    setSelectedAges(updatedAges);
  };

  const handleUpload = async () => {
    if (
      !videoData.videoName ||
      !videoData.videoDesc ||
      selectedAges.length === 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Заповніть усі поля, включаючи вікові категорії!",
      });
      return;
    }

    try {
      const newVideoData = {
        ...videoData,
        ageCategories: selectedAges.filter((age) => age !== ""), // 🔹 Видаляємо порожні значення
      };

      const docRef = await addDoc(collection(db, "videoV"), newVideoData);
      console.log("✅ Відео успішно додано до Firebase:", docRef.id);

      Swal.fire({
        icon: "success",
        title: "Успішно",
        text: "Відео відгук додано!",
      });

      setVideoData({
        videoName: "",
        videoDesc: "",
        ageCategories: [],
        videoId: "",
        book_uid: "",
        bookName: "",
      });
      setSelectedAges([""]);
    } catch (error) {
      console.error("❌ Помилка при додаванні відео:", error);

      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося додати відео, спробуйте ще раз.",
      });
    }
  };

  const handleBookChange = (e) => {
    const selectedBook = books.find((book) => book.uid === e.target.value);
    setVideoData({
      ...videoData,
      book_uid: selectedBook?.uid || "",
      bookName: selectedBook?.bookName || "",
    });
  };

  return (
    <div>
      <h2>Завантажити відео відгук</h2>

      <div>
        <label htmlFor="videoName">Назва відео:</label>
        <input
          type="text"
          id="videoName"
          name="videoName"
          value={videoData.videoName}
          onChange={handleInputChange}
        />
      </div>

      <div>
        <label htmlFor="videoDesc">Опис відео:</label>
        <textarea
          id="videoDesc"
          name="videoDesc"
          value={videoData.videoDesc}
          onChange={handleInputChange}
        />
      </div>

      <div>
        <p>Вікові категорії:</p>
        {selectedAges.map((age, index) => (
          <div
            key={index}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <select
              value={age}
              onChange={(event) => handleAgeChange(index, event)}
            >
              <option value="" disabled>
                Оберіть вікову категорію
              </option>
              {ageCategories.map((category, idx) => (
                <option key={idx} value={category}>
                  {category}
                </option>
              ))}
            </select>
            {index > 0 && (
              <button type="button" onClick={() => removeAgeGroup(index)}>
                ❌ Видалити
              </button>
            )}
          </div>
        ))}
        <button type="button" onClick={addAgeGroup}>
          ➕ Додати ще вікову категорію
        </button>
      </div>

      <div>
        <label htmlFor="videoId">ID відео:</label>
        <input
          type="text"
          id="videoId"
          name="videoId"
          value={videoData.videoId}
          onChange={handleInputChange}
        />
      </div>

      <div>
        <label htmlFor="bookSelect">Виберіть книгу:</label>
        <select id="bookSelect" onChange={handleBookChange}>
          <option value="">Оберіть книгу</option>
          {books.map((book) => (
            <option key={book.uid} value={book.uid}>
              {book.bookName}
            </option>
          ))}
        </select>
      </div>

      <button onClick={handleUpload}>Завантажити відео</button>
    </div>
  );
};

export default AddVideoOglyd;
